import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import { API } from 'aws-amplify';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Practice.css';
import Day4Practice from '../../Unit2/Day4Practice/Day4Practice';
import tryAgain from '../try_again.mp3';

/**
 *  Creates and runs the practice section for Unit3 Module3
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const Practice = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [practice, setPractice] = useState(false);
  const [practiceCount, setPracticeCount] = useState(0);
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState('');
  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [changeText, setChangeText] = useState('_________');
  const [selectImage, setSelectImage] = useState(null);
  const [matchGame1, setMatchGame1] = useState(false);
  const [box1, setBox1] = useState('');
  const [box2, setBox2] = useState('');
  const [box3, setBox3] = useState('');
  const [box4, setBox4] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const [check, setCheck] = useState(false);
  const [answer, setAnswers] = useState(Array.apply(null, Array(4)));
  const [boxSelete, setBoxSelete] = useState([false, false, false, false]);
  const [idx, setIdx] = useState(0);
  const [practice_video1, setPractice_Video1] = useState(false);
  const [practiceVideo1, setPracticeVideo1] = useState(false);
  const [practiceReview, setPracticeReview] = useState(false);
  const [practiceRrcording, setPracticeRrcording] = useState(false);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module13Images/Unit3Mod3_JourneyMap.png');
  const Exit = generateImageUrl('images/Images/close.png');
  const crab_calm = generateImageUrl('images/Module11Images/CharacterScene_Crab_Calm.png');
  const crab_confident = generateImageUrl('images/Module11Images/CharacterScene_Crab_Confident@2x.png');
  const crab_happy = generateImageUrl('images/Module11Images/CharacterScene_Crab_Happy@2x.png');
  const crab_mad = generateImageUrl('images/Module11Images/CharacterScene_Crab_Mad@2x.png');
  const crab_sad = generateImageUrl('images/Module11Images/CharacterScene_Crab_Sad@2x.png');
  const crab_nervous = generateImageUrl('images/Module11Images/CharacterScene_Crab_Nervous@2x.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');

  const options = [{
      text: 'Body Tall',
      id: 'tall',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_BodyTall@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_3.mp3',
  }, {
      text: 'Calm down and breathe',
      id: 'calm',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_Breathe@3x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_2.mp3',
  }, {
      text: 'Say how you want to feel',
      id: 'say',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_SayHowYou@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_1.mp3',
  }, {
      text: 'Think positively and sing',
      id: 'think',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_Sing@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_4.mp3',
  }, ];
  const correct = [{
      text: 'Say how you want to feel',
      id: 'say',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_SayHowYou@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_1.mp3',
  }, {
      text: 'Calm down and breathe',
      id: 'calm',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_Breathe@3x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_2.mp3',
  }, {
      text: 'Body Tall',
      id: 'tall',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_BodyTall@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_3.mp3',
  }, {
      text: 'Think positively and sing',
      id: 'think',
      img: generateImageUrl('images/Module13Images/U3M3_Practice_Sing@2x.png'),
      audio: 'appfiles/change_feelings/change_feelings_step_4.mp3',
  }, ];

  // More variables used to determine whether the order is correct or not.
  const [sortedOptions, setSortedOptions] = useState(null);
  const matchCrabs = {
    calm: crab_calm,
    confident: crab_confident,
    happy: crab_happy,
    mad: crab_mad,
    sad: crab_sad,
    nervous: crab_nervous,
  };

  // Gets the gifs that allow the lizard to talk.
  useEffect(() => {
    setIntroSound(getVideo('appfiles/change_feelings/change_feelings_choose_feeling.mp3', login));
  }, []);

  // Highlights the boxes in a line one after another
  useEffect(() => {
    for (let i = 0; i < 4; i++) {
      if (!boxSelete[i]) {
        switch (i) {
          case 0:
            setBox1('glow');
            setBox2('');
            setBox3('');
            setBox4('');
            break;
          case 1:
            setBox1('');
            setBox2('glow');
            setBox3('');
            setBox4('');
            break;
          case 2:
            setBox1('');
            setBox2('');
            setBox3('glow');
            setBox4('');
            break;
          case 3:
            setBox1('');
            setBox2('');
            setBox3('');
            setBox4('glow');
            break;
          default:
            setBox1('');
            setBox2('');
            setBox3('');
            setBox4('');
            break;
        }
        break;
      }
    }
  }, [setAnswer]);

  // Decide what video to show based on what day we're on.
  useEffect(() => {
    if(props.unit4){
      setDisplayPracticeVideo(props.reviewVideo);
        setPracticeVideo(true);
    }
    else{
      switch (props.module.currentday) {
        case 1:
          setDisplayPracticeVideo(getVideo('appfiles/change_feelings/practice_day_1.mp4', login));
          setPracticeVideo(true);
          break;
        case 2:
          setDisplayPracticeVideo(getVideo('appfiles/change_feelings/practice_day_2.mp4', login));
          setPracticeVideo(true);
          break;
        case 3:
          setDisplayPracticeVideo(getVideo('appfiles/change_feelings/practice_day_3.mp4', login));
          setPracticeVideo(true);
          break;
        default:
          setPractice(true);
          setQuestion(true);
          break;
      }
    }
  }, []);

  // Play different videos based on what emotion we are talking about
  useEffect(() => {
    switch (changeText) {
      case 'happy':
        setPractice_Video1('Module13/4step_happy.mp4');
        break;
      case 'calm':
        setPractice_Video1('Module13/4step_calm.mp4');
        break;
      case 'confident':
        setPractice_Video1('Module13/4step_confident.mp4');
        break;
      default:
        setPractice_Video1('');
        break;
    }
  }, [changeText]);

  // Set a timer for ms milliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Sets up the game initially, by setting the order of options to be random and setting up the variables
  async function setupGame(feeling) {
    setChangeText(feeling);
    setSelectImage(matchCrabs[feeling]);
    if(practice){
      const element = document.getElementById('selectCrab13');
      element.style.backgroundColor = 'transparent';
      const audio = new Audio(
        generateImageUrl('media/Module1Videos/button_accept_item.mp3')
      );
      audio.play();
    }
    setSortedOptions(
      options
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value)
    );
    setQuestion(false);
    setIntroSound(getVideo('appfiles/change_feelings/change_feelings_move_characters.mp3', login));
    if(practice){
      setTimeout(
        () => (setMatchGame1(true), setPractice(false), setQuestion(true)),
        1000
      );
    }
    else{
      setMatchGame1(true);
      setQuestion(true);
    }
  }

  // Determines if the user&apos;s ordering of the images is correct
  async function setAnswer(action) {
    setQuestion(false);
    setAnimalVoice('');
    setAnimaTalk(false);
    setAnimalVoice(await getVideo(action.audio, login));
    setAnimaTalk(true);
    for (let i = 0; i < 4; i++) {
      if (!boxSelete[i]) {
        answer[i] = action;
        boxSelete[i] = true;
        break;
      }
    }
    document.getElementById(action.id).style.opacity = 0;
    document.getElementById(action.id).style.pointerEvents = 'none';

    setAnswers(answer);
    setBoxSelete(boxSelete);
    setIdx(idx + 1);
  }

  // Resets the game back to its initial position (done if the user is wrong)
  function reset() {
    for (let i = 0; i < 4; i++) {
      if (boxSelete[i]) {
        document.getElementById(answer[i].id).style.opacity = 1;
        document.getElementById(answer[i].id).style.pointerEvents = 'auto';
        answer[i] = null;
        boxSelete[i] = false;
      }
    }
    setBoxSelete(boxSelete);
    setAnswers(answer);
    setIdx(0);
  }

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_change_feelings",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 4 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const recording = async () => {
    updateScore();
    props.module.sectionCompleted = props.module.sectionCompleted + 1
    if (props.module.currentday <= 3 && !props.unit4) {
      const text = [
        'Ask Mrs. Johnson, "What is your favorite color?"',
        'Ask Mrs. Johnson, "What is your favorite animal?"',
        'Ask Mrs. Johnson, "What is your favorite food?"',
      ];
      const introVideo = '6e8c35006cb995722b31d50d6f5d/480.m3u8';
      const influencers = [
        login.influencerid,
        login.influencerid1,
        login.influencerid2,
      ];
      let response = getVideo(`appfiles/ask/ask_response_${props.module.currentday + 4}.mp4`, login)
      let voice1 = getVideo(`appfiles/ask/ask_practice_record_${props.module.currentday + 4}.mp3`, login)
      let voice2 = getVideo(`appfiles/ask/ask_practice_special_message.mp3`, login)
      let voice3 = getVideo(`appfiles/ask/ask_practice_watch_conversation.mp3`, login)
      let voice4 = getVideo(`appfiles/ask/ask_awesome_job.mp3`, login)
      let greeting = getVideo(`appfiles/ask/ask_greeting_${props.module.currentday + 4}.mp4`, login)
      let acknowledge7 = getVideo(`appfiles/ask/ask_acknowledge_${props.module.currentday + 4}.mp4`, login)
      let question7 = getVideo(`appfiles/ask/ask_question_${props.module.currentday + 4}.mp4`, login)
      let influencerVideo = await GetUserVideo(`influencers/${influencers[props.module.currentday - 1]}/ask_video_message.mp4`)
      let greetingResponse = await GetUserVideo(`userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`)
      let response7 = await GetUserVideo(`userfiles/${props.module.StudentID}/understand_feelings_practice_video_${props.module.currentday}.mp4`)
      setPracticeRrcording(
        <Day4Practice
          module={props.module}
          celebrateVideo={introVideo}
          response7={response7}
          greetingResponse={greetingResponse}
          acknowledge7={acknowledge7}
          question7={question7}
          animate2={props.specialMessage}
          animate3={props.watchConversation}
          animate4={props.amazingJob}
          background={background}
          response={response}
          influencerVideo={influencerVideo}
          text={
            text[props.module.currentday - 1]
          }
          voice1={voice1}
          voice2={voice2}
          voice3={voice3}
          voice4={voice4}
          name={`change_feelings_practice_video_${props.module.currentday}.mp4`}
          greeting={greeting}
          closeVoice={voice4}
          animal={props.animal}
          setDisplayDay4Practice={
            props.setDisplayPractice
          }
          moduleNum={'MODULE13'}
          bigAnimal={true}
          lizard={true}
        />
      );
      setPracticeVideo1(false);
      setPracticeReview(true);                                 
      // setMatchGame1(false);
    } else {
      if (props.module.reviewIcon === false) {
        dispatch({ type: props.stepComplete, payload: 'practice' });
      }
      props.setDisplayPractice(false);
    }
  };

  // The HTML code for the practice module
  return (
    <>
      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/changefeelings'
          background={background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeVideo(false);
            switch (props.module.currentday) {
              case 1:
                setupGame('calm')
                break;
              case 2:
                setupGame('happy')
                break;
              case 3:
                setupGame('confident')
                break;
              default:
                setPractice(true);
                setQuestion(true);
                break;
            }

          }}
        />
      )}
      {practiceVideo1 && (
        <CloudfrontVideoFormat
          source={practice_video1}
          back='/changefeelings'
          background={background}
          close={props.setDisplayPractice}
          ended={() => {
            // setPracticeVideo1(false);
            // props.setDisplayPractice(false)
            recording();
          }}
        />
      )}
      {practice && (
        <div
          className='Module13Practice'
          style={{ backgroundImage: `url(${background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            alt=''
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>How do you want to feel?</h2>
          <h3 className='practiceQuestion12'>I want to feel {changeText}.</h3>
          <img alt='' id='selectCrab13' src={selectImage} />

          <div className='grid13'>
            <div className='optionImage' onClick={() => setupGame('calm')}>
              <div className='set'>
                <img alt='' className='crabExpression13' src={crab_calm} />
                <h3 className='practiceText12'>Calm</h3>
              </div>
            </div>
            <div className='optionImage' onClick={() => setupGame('happy')}>
              <div className='set'>
                <img alt='' className='crabExpression13' src={crab_happy} />
                <h3 className='practiceText12'>Happy</h3>
              </div>
            </div>
            <div className='optionImage' onClick={() => setupGame('confident')}>
              <div className='set'>
                <img alt='' className='crabExpression13' src={crab_confident} />
                <h3 className='practiceText12'>Confident</h3>
              </div>
            </div>
          </div>
        </div>
      )}

      {matchGame1 && (
        <div
          className='Module13Practice'
          style={{ backgroundImage: `url(${background})` }}
        >
          <img
            className='back-btn-ftb'
            alt=''
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            Click the characters in the correct order
          </h2>
          {(
            <img
              className='greenCheckPractice12'
              src={greenCheck}
              style={{opacity : boxSelete.every((v) => v === true) ? 1 : 0, pointerEvents : boxSelete.every((v) => v === true) ? "auto" : "none"}}
              alt=''
              onClick={() => {
                if (answer.every((v, i) => v.id === correct[i].id)) {
                  if(firstTime) setScore(4);
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  sleep(2000).then(() => {
                    setMatchGame1(false);
                    setPracticeVideo1(true);
                  });
                } else {
                  const tryAgainAudio = new Audio(tryAgain)
                  tryAgainAudio.play()
                  let total = 0;
                  for (let i = 0; i < 4; i++) {
                    if (correct[i].id !== answer[i].id) {
                      document.getElementById(answer[i].id).style.opacity = 1;
                      document.getElementById(answer[i].id).style.pointerEvents = 'auto';
                      answer[i] = null;
                      boxSelete[i] = false;
                    }
                    else{
                      total += 1
                    }
                  }
                  if(firstTime){setScore(total); setFirstTime(false);}
                  setBoxSelete(boxSelete);
                  setAnswers(answer);
                  setIdx(0);
                }
              }}
            />
          )}
          <br />
          <div className='gameGrid13Top'>
            {answer[0] ? (
              <div className='optionImage13'>
                <img alt='' className='option13' src={answer[0].img} />
              </div>
            ) : (
              <div className='optionBox' id={box1}>
                <h1>Step 1</h1>
                <div className='set'></div>
              </div>
            )}
            {answer[1] ? (
              <div className='optionImage13'>
                <img alt='' className='option13' src={answer[1].img} />
              </div>
            ) : (
              <div className='optionBox' id={box2}>
                <h1>Step 2</h1>
                <div className='set'></div>
              </div>
            )}
            {answer[2] ? (
              <div className='optionImage13'>
                <img alt='' className='option13' src={answer[2].img} />
              </div>
            ) : (
              <div className='optionBox' id={box3}>
                <h1>Step 3</h1>
                <div className='set'></div>
              </div>
            )}
            {answer[3] ? (
              <div className='optionImage13'>
                <img alt='' className='option13' src={answer[3].img} />
              </div>
            ) : (
              <div className='optionBox' id={box4}>
                <h1>Step 4</h1>
                <div className='set'></div>
              </div>
            )}
          </div>
          <div className='gameGrid13'>
            <div
              className='optionImage13'
              id={sortedOptions[0].id}
              onClick={() => setAnswer(sortedOptions[0])}
            >
              <img alt='' className='option13' src={sortedOptions[0].img} />
            </div>
            <div
              className='optionImage13'
              id={sortedOptions[1].id}
              onClick={() => setAnswer(sortedOptions[1])}
            >
              <img alt='' className='option13' src={sortedOptions[1].img} />
            </div>
            <div
              className='optionImage13'
              id={sortedOptions[2].id}
              onClick={() => setAnswer(sortedOptions[2])}
            >
              <img alt='' className='option13' src={sortedOptions[2].img} />
            </div>
            <div
              className='optionImage13'
              id={sortedOptions[3].id}
              onClick={() => setAnswer(sortedOptions[3])}
            >
              <img alt='' className='option13' src={sortedOptions[3].img} />
            </div>
          </div>
          <button
            style={{
              position: 'absolute',
              bottom: '0',
              width: '140px',
              marginLeft: '-70px',
              height: '60px',
              fontWeight: 'bold',
              backgroundColor: 'rgb(255, 105, 105)',
              borderColor: 'rgb(255, 105, 105)',
            }}
            onClick={() => {
              reset();
            }}
          >
            Reset
          </button>
        </div>
      )}

      {practiceReview && practiceRrcording}

      {!animalTalk && question && (
        <audio autoPlay onEnded={() => setQuestion(false)}>
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimalVoice('');
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
    </>
  );
};
export default Practice;
